import { NgModel, RequiredValidator } from '@angular/forms';

import { ValueAccessorBase } from './value-accessor';

import {
  AsyncValidatorArray,
  ValidatorArray,
  ValidationResult,
  message,
  validate,
} from './validate';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export abstract class ElementBase<T> extends ValueAccessorBase<T> {
  protected abstract model: NgModel;

  constructor(
    private validators: ValidatorArray,
    private asyncValidators: AsyncValidatorArray,
  ) {
    super();
  }

  protected validate(): Observable<ValidationResult> {
    return validate
      (this.validators, this.asyncValidators)
      (this.model.control);
  }

  get invalid(): Observable<boolean> {
    return this.validate().pipe(map(v => Object.keys(v || {}).length > 0));
  }

  protected get failures(): Observable<Array<string>> {
    return this.validate().pipe(map(v => Object.keys(v).map(k => message(v, k))));
  }

  get required(): boolean {
    if (!this.validators) {
      return false;
    }

    for (let index = 0; index < this.validators.length; index++) {
      const requiredValidator = this.validators[index] as RequiredValidator;
      if (requiredValidator) {
        return requiredValidator.required === true || requiredValidator.required === 'true' || requiredValidator.required === 'required';
      }
    }

    return false;
  }
}
